const ACCESS_TOKEN_KEY = 'access_token';
const TOKEN_EXPIRATION = 'token_expiration';
const REFRESH_TOKEN = 'refresh_token';

export function login(e){
  e.preventDefault();
  window.location = 'https://s0pagy2hj3.execute-api.us-east-1.amazonaws.com/prod/spotify-authorize/';
}

export function logout(){
  clearAccessToken();
  window.location = '/';
}

export function getAccessToken(){
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

function clearAccessToken(){
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

function getTokenExpirationDate(){
  return localStorage.getItem(TOKEN_EXPIRATION);
}

// Get and store access_token in local storage
export function setAccessToken(accessToken, refreshToken) {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(REFRESH_TOKEN, refreshToken);

  let time = new Date();
  let expires = new Date(time.getTime() + 50*60000);
  localStorage.setItem(TOKEN_EXPIRATION, expires.toISOString());
}

export function isLoggedIn() {
  const accessToken = getAccessToken();
  return !!accessToken && !isTokenExpired();
}

function isTokenExpired() {
  const expirationDate = getTokenExpirationDate();
  return expirationDate < new Date().toISOString();
}


// WEBPACK FOOTER //
// ./src/utils/AuthService.js